export function eventOptionsKey(normalizedEventOptions) {
    if (!normalizedEventOptions) {
        return 0;
    }
    if (normalizedEventOptions === true) {
        return 1;
    }
    var capture = normalizedEventOptions.capture ? 2 : 0;
    var passive = normalizedEventOptions.passive ? 4 : 0;
    var once = normalizedEventOptions.once ? 8 : 0;
    return capture | passive | once;
}
